// Mode controller factory.
//
// Maps a PetVariant to its controller. Adding a new pet variant only requires:
//   1. implementing a controller module that satisfies PetController, and
//   2. registering it here.

import type { ControllerContext, PetController, PetVariant } from './types';
import { createGhostController } from './ghost';
import { createClawdController } from './clawd';

export type { PetController, PetVariant, Mood, Behavior, Vec2, ControllerContext } from './types';

export function createModeController(
  variant: PetVariant,
  ctx: ControllerContext
): PetController {
  switch (variant) {
    case 'ghost':
      return createGhostController(ctx);
    case 'clawd':
      return createClawdController(ctx);
    default:
      return createGhostController(ctx);
  }
}
